import './enum-labels'

import type { ValidatedField } from '../../constants/validated-field'

import { HOUSE_ELEMENT_MODE_LABELS } from './enum-labels'
import { TERMS } from './terms'
import { fieldName, VALIDATION } from './validation'

const UNGROUPED = 'Ohne Gruppe'

export const HOUSE_ELEMENT_TYPE = {
  pageSubtitleGrouped:
    'Element-Typen in Gruppen organisieren. Im Planungs-Tab wird pro Gruppe eine eigene Sektion angezeigt.',
  add: 'Typ hinzufügen',
  edit: 'Typ bearbeiten',
  actionFailed: 'Aktion fehlgeschlagen.',
  search: 'Element-Typ suchen …',
  noResults: 'Kein Element-Typ passt zur Suche.',
  groups: {
    addGroup: `${TERMS.group} hinzufügen`,
    addType: 'Element-Typ hinzufügen',
    defaultName: `Neue ${TERMS.group}`,
    deleteGroup: `${TERMS.group} löschen`,
    deleteConfirmMessage: (n: number, name: string) =>
      `Gruppe "${name}" löschen? Die ${n} enthaltenen Element-Typen bleiben erhalten und landen in "${UNGROUPED}".`,
    empty: 'Noch keine Gruppen — klicke "Gruppe hinzufügen".',
    itemCount: (n: number) => (n === 1 ? `${n} Element` : `${n} Elemente`),
    ungrouped: UNGROUPED,
    usageCount: (n: number) =>
      `${n} ${n === 1 ? TERMS.usage : TERMS.usagePlural}`,
    unusedShort: TERMS.unused,
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
  },
  fields: {
    key: 'Key (camelCase) — auch Konfigurator-Formel-Variable',
    keyHint:
      'camelCase-Kennung, z. B. interiorDoors. Nach dem Anlegen nicht mehr änderbar. Wird später vom Konfigurator als Variable im Formel-Scope genutzt.',
    mode: 'Modus',
    modeImmutableHint: 'Modus ist nach dem Anlegen fix.',
    scope: 'Bereich',
    scopeImmutableHint: 'Bereich ist nach dem Anlegen fix.',
    rangePlaceholder: '—',
    descriptionPlaceholder:
      'Kurzer Hilfetext, wird im Planungsbereich per Info-Icon angezeigt',
    isRequired: VALIDATION.required,
    isRequiredHint:
      'Zeigt einen roten Stern neben dem Feld im Planungsbereich. Keine harte Validierung — dient nur als visueller Hinweis.',
    optionLabelPlaceholder: 'Bezeichnung (z. B. Holz)',
  },
  delete: {
    confirmTitle: 'Typ löschen',
    confirmMessage: 'Diesen Typ wirklich löschen?',
    blockedByUsageTitle: 'Löschen nicht möglich',
    blockedByUsageMessage: (n: number) =>
      `Es gibt noch ${n} Instanzen dieses Typs. Lösche zuerst die Instanzen.`,
  },
  /** What the endpoints report back when a type or option is rejected. */
  errors: {
    keyCollidesWithBuiltin: (key: string) =>
      `Der Key „${key}“ ist bereits als Variable oder Formel-Funktion vergeben.`,
    keyTaken: 'Dieser Key ist bereits vergeben.',
    optionModeNeedsOption: `Ein Typ im Modus „${HOUSE_ELEMENT_MODE_LABELS.OPTION}“ braucht mindestens eine Option.`,
    optionsOnlyOnOptionMode: `Optionen sind nur im Modus „${HOUSE_ELEMENT_MODE_LABELS.OPTION}“ erlaubt.`,
    fieldOnlyOnQuantityMode: (field: ValidatedField) =>
      `${fieldName(field)} ist nur bei Typen im Modus "${HOUSE_ELEMENT_MODE_LABELS.QUANTITY}" erlaubt.`,
    stillUsed: (key: string, count: number) =>
      count === 1
        ? `„${key}“ kann nicht gelöscht werden: 1 Element verweist noch darauf.`
        : `„${key}“ kann nicht gelöscht werden: ${count} Elemente verweisen noch darauf.`,
    optionsStillUsed: (keys: string) =>
      `Diese Optionen werden noch verwendet und können nicht gelöscht werden: ${keys}.`,
  },
} as const
